// Parameters primarily used by the frontend.
export const enum QueryParameter {
  Language = 'lang',
  Brand = 'brand',
  Default = 'default',
  Page = 'page',
  QuestionId = 'questionId',
  ShowAuth = 'show_auth',
  Teacher = 'teacher_id',
  User = 'user_id',
  ForceShowReportButton = 'showReportButton',
}

// Namespace for parameters used by the backend.
export const enum SearchParameter {
  After = 'after',
  Before = 'before',
  Direction = 'direction',
  Language = 'language',
  Order = 'order',
  PageSize = 'page_size',
  Prefix = 'prefix',
  Query = 'query',
  ResolutionStrategy = 'resolution_strategy',
  Start = 'start',
  StrictlyAfter = 'strictly_after',
  StrictlyBefore = 'strictly_before',
  Teacher = 'teacher_id',
  TimeOverlap = 'time_overlap',
  TranslationLanguage = 'translation_language',
  User = 'user_id',
  Draft = 'draft',
}

export const enum Direction {
  Ascending = 'asc',
  Descending = 'desc',
}

export const enum Order {
  CategoryPosition = 'category_position',
  CoursePosition = 'course_position',
  CreatedAt = 'created_at',
  CurriculumPosition = 'curriculum_position',
  Email = 'email',
  EndsAt = 'ends_at',
  FirstPublishedAt = 'first_published_at',
  Id = 'id',
  Name = 'name',
  Relevance = 'relevance',
  StaffEmail = 'staff_email',
  StartsAt = 'starts_at',
  TargetLevelRangeMax = 'target_level_range_max',
  TargetLevelRangeMin = 'target_level_range_min',
  UsageQuestionCreatedAt = 'usage_question_created_at',
  Word = 'word',
}

export const enum ResolutionStrategy {
  Either = 'either',
  Scope = 'scope',
  Search = 'search',
}

export const enum Draft {
  Both = 'both',
  True = 'true',
  False = 'false',
}
